import { getStoredOrgSlug } from './auth';

// orgRoute prepends the signed-in tenant's slug to a tenant-scoped
// path so `<Link to={orgRoute('/fleet')}>` resolves to
// '/acme/fleet'. The slug comes from /v1/auth/login (stored under
// localStorage['pdm.tenant_slug']); the router's beforeLoad guard
// validates that the slug in the URL matches the one on file and
// redirects on mismatch (e.g. someone bookmarked /beta/fleet but
// signs in as acme).
//
// Passing a path that doesn't start with '/' is a programming error
// and throws — we'd silently produce a malformed URL otherwise.
//
// Bypass paths (auth, invite, radiant, root '/') don't carry the
// org scope and are reached via `<Link to="/auth">` directly — don't
// route them through this helper.
export function orgRoute(path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`orgRoute: path must start with '/' (got ${JSON.stringify(path)})`);
  }
  const slug = getStoredOrgSlug();
  if (!slug) {
    // No slug means we're not signed in yet — the route guard will
    // bounce to /auth before any of these links render. Return the
    // bare path so TypeScript stays happy and so a stray render
    // doesn't 404.
    return path;
  }
  return `/${encodeURIComponent(slug)}${path}`;
}

// orgRouteFor lets callers (notably the post-login redirect) target
// a specific slug instead of reading the stored one. Useful in the
// /auth onSuccess handler where the slug arrives in the response
// body before being written to localStorage.
export function orgRouteFor(slug: string, path: string): string {
  if (!path.startsWith('/')) {
    throw new Error(`orgRouteFor: path must start with '/' (got ${JSON.stringify(path)})`);
  }
  return `/${encodeURIComponent(slug)}${path}`;
}
